import { atom, createStore } from 'jotai';
import { atomWithPersist } from './helper';
import { ResultsDrawerSize, ResultsDrawerState } from './enum';

export const store = createStore();

export const mapCamerasAtom = atomWithPersist(store, 'engageResults', 'mapCameras', {});

export const drawerStateAtom = atom(ResultsDrawerState.EXPANDED);
export const drawerSizeAtom = atom(ResultsDrawerSize.DEFAULT);
